<!-- <script>
/* eslint-disable */
</script> -->

<template>
    <div>
        <!--表单-->

        <el-form :model="formData" :rules="formRules" ref="dataForm">
            <el-descriptions
                class="margin-top"
                :data="list"
                title="问题"
                :column="1"
                :size="size"
                border
            >
                <el-descriptions-item
                    label="questionId"
                    v-model="formData.questionId"
                    prop="orderNum"
                    >{{ list[0].id }}</el-descriptions-item
                >

                <el-descriptions-item
                    label="问题序号"
                    v-model="formData.orderNum"
                    prop="orderNum"
                    >{{ list[0].orderNum }}</el-descriptions-item
                >

                <el-descriptions-item
                    label="问题"
                    v-model="formData.question"
                    prop="question"
                    >{{ list[0].question }}</el-descriptions-item
                >

                <el-descriptions-item
                    label="Question"
                    v-model="formData.questionEn"
                    prop="questionEn"
                    >{{ list[0].questionEn }}</el-descriptions-item
                >

                <!-- <el-radio-group v-model="list[0].answerList">
                                <el-radio v-for="item in list[0].answerList" :key="item.value" :value="item.value" :label="item.value">{{item.value}}                        </el-radio>
                            </el-radio-group> -->
            </el-descriptions>

            <el-form-item label="questionId" value=""></el-form-item>
            <!-- <el-form-item label="请选择：" prop="jumpType2">
                <el-radio-group v-model="formData.answerId">
                    <el-radio
                        v-for="item in answerList"
                        v-loading="answerLoading"
                        :label="item.id"
                        border
                        size="max"
                            >{{ item.answer }}</el-radio
                        >
                    </el-radio-group>
                </el-form-item> -->

            <br />

            <!-- <el-button @click.native="hideForm">取消</el-button>-->
            <el-button
                type="primary"
                @click.native="formSubmit()"
                :loading="formLoading"
                >提交</el-button
            >
            &nbsp;
            <router-link
                :to="{
                    path: '/public/risk_question',
                    query: {
                        orderNum: parseInt(this.query.orderNum) - 1,
                        investorId: parseInt(this.query.investorId),
                    },
                }"
                @click.native="flushCom"
            >
                <el-button type="primary">上一题</el-button>
            </router-link>
            &nbsp;
            <router-link
                :to="{
                    path: '/public/risk_question',
                    query: {
                        orderNum: parseInt(this.query.orderNum) + 1,
                        investorId: parseInt(this.query.investorId),
                    },
                }"
                @click.native="flushCom"
            >
                <el-button type="primary">下一题</el-button>
            </router-link>
        </el-form>
        <br />

        <!-- <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.id">
                                <el-radio  :label="scope.row.answer" prop="answer">{{scope.row.answer}}</el-radio> 
                </el-radio-group>
                </template> -->

        <!-- 
                <el-table v-loading="answerLoading" :data="answerList" style="width: 100%;">
                   
                <el-table-column label="answer ID" prop="id">
                    <template slot-scope="scope">
                        <el-radio-group v-model="scope.row.id">
                            <el-radio  :label="scope.row.answer" prop="answer">{{scope.row.answer}}</el-radio> 
                        </el-radio-group>
                        
                    </template>
                </el-table-column>
                    <el-table-column label="答案" prop="answer">
                </el-table-column>
                 <el-table-column label="顺序" prop="orderNum" fixed>
                </el-table-column> -->
        <!-- <el-table-column label="Answer" prop="answerEn" with="300" :show-overflow-tooltip="true">
                    </el-table-column> 
            
            </el-table>  -->

        <!-- <ui v-if="list.length>0"> -->
        <!-- <li v-for="item of list">
                        {{item.orderNum}} - {{item.question}}
                    </li> -->
    </div>
</template>
<route-view :key="$route.fullPath"></route-view>
<script>
import {
    questionList,
    investorQASaveOrEdit,
    //answerList,
} from "../../api/public/riskInvestor";
//import Upload from "../../components/File/Upload.vue";
//import { Message } from "element-ui";

//提交用的数据
const formJson = {
    answerId: 0,
    questionId: 0,
    investorId: 0,
};
export default {
    data() {
        return {
            query: {
                questionId: 0,
                orderNum: 1,
                //title: "",
                //page: 1,
                limit: 20,
            },
            list: [],
            total: 0,
            loading: true,
            index: null,
            formName: "add",
            formMap: {
                add: "新增",
                edit: "编辑",
            },
            formLoading: false,
            formVisible: true,
            formData: formJson,
            deleteLoading: false,

            answerId: 0,
            answerList: [],
            answerTotal: 0,
            answerLoading: true,
            questionId: 0,
        };
    },
    components: {
        //Upload
    },
    watch: {
        $route() {
            //this.getList();
        },
    },
    computed: {
        key() {
            return this.$route.path + Math.random();
        },
    },
    methods: {
        flushCom() {
            location.reload();
            this.$route.go(0);
            this.getList();
        },
        onReset() {
            this.$router.push({
                path: "",
            });
            this.query = {
                questionId: 0,
                title: "",
                page: 1,
                limit: 20,
            };
            this.getList();
        },
        onSubmit() {
            this.$router.push({
                path: "",
                query: this.query,
            });
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        getList() {
            this.loading = true;
            this.answerLoading = true;
            questionList(this.query)
                .then((response) => {
                    this.loading = false;
                    this.list = response.data.list || [];
                    this.total = response.data.total || 0;
                    this.questionId = response.data.list[0].id;

                    this.answerLoading = false;
                    this.answerList = response.data.answerList || [];
                    this.answerTotal = response.data.answerTotal || 0;
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                    this.answerLoading = false;
                    this.answerList = [];
                    this.answerTotal = 0;
                });
        },

        // 刷新表单
        resetForm() {
            if (this.$refs["dataForm"]) {
                // 清空字段
                this.$refs["dataForm"].resetFields();
                // 清空验证信息表单
                this.$refs["dataForm"].clearValidate();
            }
        },
        // 隐藏表单
        hideForm() {
            // 更改值
            this.formVisible = !this.formVisible;
            return true;
        },
        // 显示表单
        handleForm(index, row) {
            this.formVisible = true;
            // 刷新表单
            this.resetForm();
            this.formData = JSON.parse(JSON.stringify(formJson));
            if (row !== null) {
                this.formData = Object.assign({}, row);
            }
            this.formName = "add";
            if (index !== null) {
                this.index = index;
                this.formName = "edit";
            }
        },
        formSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    this.formLoading = true;
                    let data = Object.assign({}, this.formData);
                    // 对：Message.info("this.questionId : "+ this.questionId);
                    data.questionId = this.questionId;
                    data.investorId = parseInt(this.query.investorId);
                    investorQASaveOrEdit(data, this.formName)
                        .then((response) => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            this.formVisible = false;
                            if (this.formName === "add") {
                                // 向头部添加数据
                                data.adId = response.data.adId;
                                this.list.unshift(data);
                            } else {
                                this.list.splice(this.index, 1, data);
                            }
                        })
                        .catch(() => {
                            this.formLoading = false;
                        });
                }
            });
        },
    },
    filters: {
        statusFilterType(status) {
            const statusMap = {
                0: "gray",
                1: "success",
            };
            return statusMap[status];
        },
        statusFilterName(status) {
            const statusMap = {
                0: "禁用",
                1: "正常",
            };
            return statusMap[status];
        },
    },
    mounted() {
        //Message.info("mount");
        //this.getList();
    },
    created() {
        // 将参数拷贝进查询对象
        //Message.info("create");
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.limit = parseInt(this.query.limit);
        //this.query.questionId = parseInt(this.query.questionId);
        // 加载表格数据
        this.getList();
        //Message.info("store.getters.investorId: " + store.getters.investorId);
    },
};
</script>

<style type="text/scss" lang="scss"></style>
